export enum TncStep {
  REVIEW_CASE = 1,
  START_TNC = 2,
  EMPLOYEE_AVAILABILITY = 3,
  EMAIL_FAN = 4,
  TNC_INSTRUCTIONS = 5,
  EMPLOYEE_DECISION = 6,
  SIGNATURE = 7,
  DOWNLOAD_RDC = 8,
  CASE_CLOSURE = 9,
}
